import { darkTheme, lightTheme, slateDarkTheme, slateLightTheme, textTheme } from "@octopusdeploy/design-system-tokens";

/**
 * This setup executes after the page has loaded, but before the main App chunk is loaded.
 * This gives us access to theme tokens for the loading screen.
 */

// We don't have access to common utilities for theme/localStorage so this is duplicated to decouple us from the main App chunk.
const themeJSON = localStorage.getItem("theme");
const themeName = themeJSON ? JSON.parse(themeJSON) : "unassigned";
const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
const resolvedThemeName = themeName === "unassigned" ? (prefersDark ? "dark" : "light") : themeName;

const themesByName: Partial<Record<string, typeof lightTheme>> = { light: lightTheme, dark: darkTheme, slateLight: slateLightTheme, slateDark: slateDarkTheme };
const theme = themesByName[resolvedThemeName] ?? lightTheme;

export function setupInitialTheme() {
    const themeCssVariableProps = Object.entries(theme)
        .concat(Object.entries(textTheme))
        .map(([cssVariableName, value]) => `--${cssVariableName}: ${value};`);

    const serializedCss = `:root {
${themeCssVariableProps.join("\n")}
}`;

    const styleElement = document.createElement("style");
    styleElement.setAttribute("id", globalStyleNodeId);
    styleElement.innerHTML = serializedCss;
    document.head.appendChild(styleElement);
}

// This uses the same global style node id as GlobalThemeApplier. This is a minor optimization so the node is reused instead of duplicatad.
const globalStyleNodeId = "octopus-global-theme";
